import { useEffect, useState } from 'react';
import { Column } from '@ant-design/plots';
import { formatarReal, getUltimoDiaMes } from '../functions/funcoes';
import { iConsolidado } from '../interfaces/iFinanceiro';
import { Typography, Flex } from 'antd';
import { getHeight } from '../functions/funcoes';
import { Azul, FluxoCaixa, SaldoContas } from '../constants/Cores';

const { Text } = Typography;

const CtConsolidado = () => {
  const [dados, setDados] = useState<iConsolidado[]>([]);
  let TextType: 'success' | 'danger' | undefined = undefined;

  useEffect(() => {
    window.addEventListener('fluxoDelphi', (event: any) => {
      const dadosRecebidos = event.detail;
      setDados(dadosRecebidos);
    });
  }, []);

  function getAltura() {
    let AAltura = {
      A1920xL1080: 180,
      A1680xL1050: 180,
      A1600xL900: 149,
      A1440xL900: 149,
      A1400xL1050: 149,
      A1366xL768: 130,
      A1280xL1024: 149,
      A1280xL960: 149,
      A1280xL800: 139,
      A1280xL768: 139,
      A1280xL720: 139,
      A1280xL600: 139,
      A1152xL864: 139,
      A1024xL768: 138,
      A800xL600: 138,
    };

    return getHeight(AAltura);
  }

  let Soma = dados.reduce((total, d) => d.name !== 'Provisão (pagar)' ? total + d.valor : total, 0);
  let Pagar = dados.reduce((total, d) => d.name === 'Provisão (pagar)' ? total + d.valor : total, 0);
  Soma = Soma - Pagar;
  if (Soma > 0) {
    TextType = 'success';
  } else if (Soma < 0) {
    TextType = 'danger';
  } else {
    TextType = undefined
  };

  const config = {
    data: dados,
    xField: 'name',
    yField: 'valor',
    colorField: 'name',
    height: getAltura(),
    autoFit: true,
    autoResize: true,
    paddingBottom: 25,
    axis: { x: false, y: false },
    style: {
      maxWidth: 200,
    },
    scale: { color: { palette: FluxoCaixa } },
    tooltip: false,
    legend: {
      color: {
        layout: 'flex',
        cols: 0,
        maxCols: 1,
        position: 'bottom',
      }
    },
    label: {
      text: (d: iConsolidado, i: number, data: iConsolidado[]) => (formatarReal(d.valor)),
      position: 'inside',
      transform: [
        { type: 'contrastReverse' },
        { type: 'overlapDodgeY' }
      ]
    }
  };
  return (
    <>
      <Column {...config} />
      <Flex
        justify='center'
        gap="small">
        <Text>Saldo previsto</Text>
        <Text>({getUltimoDiaMes()}): </Text>
        <Text
          style={{ fontWeight: 700 }}
          type={TextType}>{formatarReal(Soma)}</Text>
      </Flex>
    </>
  )

};

export default CtConsolidado;